var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "samc-field",
    {
      attrs: {
        label: _vm.label,
        disabled: _vm.disabled,
        "error-text": _vm.errorText,
      },
    },
    [
      _c(
        "samc-dropdown",
        {
          attrs: {
            value: _setup.val,
            placeholder: _vm.placeholder,
            "enable-search": "",
          },
          on: {
            searchChanged: function ($event) {
              _setup.searchText = $event.detail
            },
            valueChanged: function ($event) {
              _setup.val = $event.detail
            },
          },
        },
        [
          _c("samc-option-source", {
            ref: "sourceOption",
            attrs: {
              "text-field": "name",
              "value-field": "id",
              "search-text": _setup.searchText,
            },
            on: {
              initialdataload: function ($event) {
                return _setup.onInitialLoad()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }